let localStorageOperating = {
  updateData: function (key, value) {
    let reData = 0
    try {
      if (window.localStorage.getItem(key) !== null) {
        this.deleteData(key)
      }
      window.localStorage.setItem(key, window.JSON.stringify(value))
      reData = 1
    } catch (error) {
      console.log('数据存储失败' + error)
      let SaveError = function (message, code) {
        this.message = message
        this.code = code
      }
      reData = 0
      // 数据存储失败还没进行回滚处理
      throw new SaveError('数据存储失败' + error, -100)
    }
    return reData
  },
  deleteData: function (key) {
    window.localStorage.removeItem(key)
  },
  getData: function (key) {
    let data = window.localStorage.getItem(key)
    return typeof data === 'undefined' || data === null ? data : JSON.parse(data)
  }
}

export const saveData = function ({key, data}) {
  localStorageOperating.updateData(key, data)
}

export const getData = function (key) {
  return localStorageOperating.getData(key)
}

export const delData = function (key) {
  return localStorageOperating.deleteData(key)
}



// WEBPACK FOOTER //
// ./src/api/local_storage.js